/**
 * Utility class to track if there is at least one operation was successful
 * Used when tracking events: some updates are optional and may or may not
 * finish successfully. If at least one is successful, we will emit the event
 */
class UpdateTracker {
  private successfulUpdate = false;

  captureError(hasError: boolean) {
    if (!hasError) {
      this.successfulUpdate = true;
    }
  }

  hasSuccessfulUpdate() {
    return this.successfulUpdate;
  }
}

export default UpdateTracker;
